(ns dashboard.entity.questionnaire.progress-bar
  "The principle contract of the dashboard.entity component namespaces are this:
   1. All components will NOT depend on keyword references to subs and events in
      external NSes, but rather receive data as arguments, functions and callbacks.
   2. All internal reliance on the re-frame app DB must be internally contained.
   3. All re-frame app subs and events must NOT be directly referenced by outside
      NSes, but rather via GETTER and SETTER functions - the same is true of internal
      calls - prefer using parameterized functions.
   4. The entity is a UI component that may encapsulate low-level business rules on
      UI controls, but is not responsible for hydrating components with data or entrenched
      references to component namespaces. The UI is customizable, and top-level entities
      should have configurable and interchangable UI elements."
  (:require [clojure.string :as str]))

(defn progress-bar
  [question-status->frequency total-question-count]
  (let [questions (keep (fn [[status :as row]]
                          (when-let [count (question-status->frequency status)]
                            (conj row count)))
                        [["approved" "hsl(141, 71%, 48%)"]
                         ["in-review" "hsl(48, 100%, 67%)"]
                         ["out-of-scope" "rgb(180, 180, 180)"]
                         [nil "rgb(206 45 77)"]])
        colors (str/join
                ", "
                (rest
                 (map second
                      (reductions
                       (fn [[old-percent] [_ color count]]
                         (let [percent (+ old-percent (Math/floor (* 100 (/ count total-question-count))))]
                           [percent (str/join ", " [(str color " " old-percent "%")
                                                    (str color " " percent "%")])]))
                       [0]
                       questions))))]
    [:div.progress-bar
     {:title (str/join "\n" (map
                             (fn [[status _ count]]
                               (str (str/capitalize (or status "Unknown")) ": " count))
                             questions))
      :style {:width "100%"
              :height "10px"
              :border-radius "12px 12px 12px 12px"
              :background (str "linear-gradient(to right, " colors ")")}}]))
